// import { Link, useMatch, useResolvedPath } from 'react-router-dom'
// import { Label, NavList } from '@primer/react'
// import React from 'react';
// import { useSelector } from 'react-redux';
// import { RootState } from '../../state/reducers';
// import { useLanguage } from '../../hooks/useLanguage';
// const NavItem = ({ to, children }: any) => {
//     const resolved = useResolvedPath(to)
//     const isCurrent = useMatch({ path: resolved.pathname, end: true })
//     return (
//         <NavList.Item as={Link} to={to} aria-current={isCurrent ? 'page' : undefined} defaultOpen>
//             {children}
//         </NavList.Item>
//     )
// }
// const Menu = () => {
//     const { user_info } = useSelector((x: RootState) => x.auth)
//     const { menu_group_id } = useSelector((x: RootState) => x.common)
//     const { language } = useLanguage();
//     return (
//         <NavList>
//             {user_info?.menus.filter(x => x.id === menu_group_id).map(menu => {
//                 return (
//                     <NavList.Group title={language === "en" ? menu.name_en : menu.name} key={menu.id}>
//                         {menu.items.map(subItem => {

//                             return (
//                                 <NavItem to={`../../../${subItem.path}`} key={subItem.id}>
//                                     <NavList.LeadingVisual>
//                                         <i className={`${subItem.icon}`}></i>
//                                     </NavList.LeadingVisual>
//                                     {language === "en" ? subItem.name_en : subItem.name}
//                                     {subItem.tags &&
//                                         <NavList.TrailingVisual>
//                                             <Label variant='success'>{subItem.tags}</Label>
//                                         </NavList.TrailingVisual>
//                                     }
//                                     {subItem.items.length > 0 &&
//                                         <NavList.SubNav>
//                                             {subItem.items.map(s => {
//                                                 return (
//                                                     <NavItem key={s.id} to={`../../../${s.path}`}>
//                                                         <NavList.LeadingVisual>
//                                                             <i className={`${s.icon}`}></i>
//                                                         </NavList.LeadingVisual>
//                                                         {language === "en" ? s.name_en : s.name}
//                                                         {s.tags &&
//                                                             <NavList.TrailingVisual>
//                                                                 <Label>{s.tags}</Label>
//                                                             </NavList.TrailingVisual>
//                                                         }
//                                                     </NavItem>
//                                                 )
//                                             })}
//                                         </NavList.SubNav>
//                                     }
//                                 </NavItem>
//                             )
//                         })}

//                     </NavList.Group>
//                 );
//             })}
//         </NavList>
//     );
// };

// export default Menu;


import { Label, NavList } from '@primer/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';
import { useLanguage } from '../../hooks/useLanguage';
import { RootState } from '../../state/reducers';

interface NavItemProps {
    to: string;
    children: React.ReactNode;
    hasSubNav?: boolean;
}

const NavItem = ({ to, children, hasSubNav }: NavItemProps) => {
    const resolved = useResolvedPath(to)
    const isCurrent = useMatch({ path: resolved.pathname, end: true })
    return (
        <NavList.Item
            as={Link}
            to={to}
            aria-current={isCurrent ? 'page' : undefined}
            defaultOpen={hasSubNav ? true : undefined}
        >
            {children}
        </NavList.Item>
    )
}

const Menu = () => {
    const { user_info } = useSelector((x: RootState) => x.auth)
    const { menu_group_id } = useSelector((x: RootState) => x.common)
    const { language } = useLanguage();   
    return (
        <NavList>
            {user_info?.menus.filter(x => x.id === menu_group_id).map(menu => {
                return (
                    <NavList.Group title={language === "en" ? menu.name_en : menu.name} key={menu.id}>
                        {menu.items.map(subItem => {
                            return (
                                <NavItem
                                    to={`../../../${subItem.path}`}
                                    key={subItem.id}
                                    hasSubNav={subItem.items.length > 0}
                                >
                                    <NavList.LeadingVisual>
                                        <i className={`${subItem.icon}`}></i>
                                    </NavList.LeadingVisual>
                                    {language === "en" ? subItem.name_en : subItem.name}
                                    {subItem.tags &&
                                        <NavList.TrailingVisual>
                                            <Label variant='success'>{subItem.tags}</Label>
                                        </NavList.TrailingVisual>
                                    }
                                    {subItem.items.length > 0 &&
                                        <NavList.SubNav>
                                            {subItem.items.map(s => {
                                                return (
                                                    <NavItem
                                                        key={s.id}
                                                        to={`../../../${s.path}`}
                                                        hasSubNav={false}
                                                    >
                                                        <NavList.LeadingVisual>
                                                            <i className={`${s.icon}`}></i>
                                                        </NavList.LeadingVisual>
                                                        {language === "en" ? s.name_en : s.name}
                                                        {s.tags &&
                                                            <NavList.TrailingVisual>
                                                                <Label>{s.tags}</Label>
                                                            </NavList.TrailingVisual>
                                                        }
                                                    </NavItem>
                                                )
                                            })}
                                        </NavList.SubNav>
                                    }
                                </NavItem>
                            )
                        })}
                    </NavList.Group>
                );
            })}
        </NavList>
    );
};

export default Menu;